import { NavLink } from "react-router-dom";
import { useAuth } from "../lib/auth-context";
import { Icon } from "./Icons";

interface NavItem {
  to: string;
  icon: string;
  label: string;
  end?: boolean;
}

const PLATAFORMA: NavItem[] = [
  { to: "/", icon: "mi-chart", label: "Panorama", end: true },
  { to: "/tenants", icon: "mi-building", label: "Alcaldías" },
  { to: "/platform/metrics", icon: "mi-chart", label: "Métricas e informes" },
];

const SISTEMA: NavItem[] = [
  { to: "/platform/config", icon: "mi-cog", label: "Configuración" },
  { to: "/platform/encuesta-base", icon: "mi-star", label: "Encuesta base" },
  { to: "/audit-log", icon: "mi-shield", label: "Auditoría" },
  { to: "/security", icon: "mi-cog", label: "Seguridad" },
];

const RECURSOS: NavItem[] = [
  { to: "/docs", icon: "mi-file", label: "Documentación" },
];

export function Sidebar({ onClose }: { onClose?: () => void }) {
  const { user, logout } = useAuth();

  return (
    <aside className="sidebar" aria-label="Navegación principal">
      <div className="sidebar-brand">
        <span className="brand-mark" aria-hidden />
        <div className="brand-text">
          <div className="brand-name">MiPueblo</div>
          <div className="brand-sub">Plataforma · super_admin</div>
        </div>
        {onClose && (
          <button
            type="button"
            className="sidebar-close"
            onClick={onClose}
            aria-label="Cerrar menú"
          >
            <Icon id="mi-x" size={18} />
          </button>
        )}
      </div>

      <nav className="sidenav" aria-label="Secciones">
        <Section label="Plataforma" items={PLATAFORMA} onNavigate={onClose} />
        <Section label="Sistema" items={SISTEMA} onNavigate={onClose} />
        <Section label="Recursos" items={RECURSOS} onNavigate={onClose} />
      </nav>

      <div className="sidebar-foot">
        {user && (
          <>
            <div className="who-block">
              <div className="avatar">
                {user.nombre.charAt(0).toUpperCase()}
              </div>
              <div className="who-text" style={{ minWidth: 0 }}>
                <div className="who-name">{user.nombre}</div>
                <div className="who-meta">
                  {user.rol}
                  {user.totp_enabled ? " · 2FA" : ""}
                </div>
              </div>
            </div>
            <button
              type="button"
              className="logout-side"
              onClick={logout}
              title="Cerrar sesión"
            >
              <Icon id="mi-logout" size={14} />
              <span className="lbl">Salir</span>
            </button>
          </>
        )}
      </div>
    </aside>
  );
}

function Section({
  label,
  items,
  onNavigate,
}: {
  label: string;
  items: NavItem[];
  onNavigate?: () => void;
}) {
  return (
    <div className="nav-group">
      <div className="nav-section">{label}</div>
      {items.map((it) => (
        <NavLink
          key={it.to}
          to={it.to}
          end={it.end}
          className={({ isActive }) =>
            isActive ? "nav-item active" : "nav-item"
          }
          onClick={onNavigate}
          title={it.label}
        >
          <Icon id={it.icon} />
          <span className="lbl">{it.label}</span>
        </NavLink>
      ))}
    </div>
  );
}
